// extracted by css-extract-rspack-plugin
export default {"list":"TIHgus"};